export default function EvolveLogo() {
  return (
    <svg
      width="133"
      height="48"
      viewBox="0 0 133 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginBottom: '25px' }}
    >
      <g clipPath="url(#clip0_289_1448)">
        <path
          d="M50.8117 16.62C52.1717 16.62 53.3517 16.92 54.3517 17.52C55.3517 18.12 56.1117 18.97 56.6317 20.07C57.1717 21.15 57.4417 22.42 57.4417 23.88V25.47H46.4317C46.4717 27.29 46.9317 28.68 47.8117 29.6399C48.7117 30.58 49.9617 31.0499 51.5617 31.0499C52.5817 31.0499 53.4817 30.96 54.2617 30.78C55.0617 30.58 55.8817 30.3 56.7217 29.94V32.25C55.9017 32.61 55.0917 32.8699 54.2917 33.0299C53.4917 33.2099 52.5417 33.2999 51.4417 33.2999C49.9017 33.2999 48.5517 32.99 47.3917 32.3699C46.2317 31.7499 45.3217 30.83 44.6617 29.61C44.0217 28.39 43.7017 26.88 43.7017 25.08C43.7017 23.32 43.9917 21.81 44.5717 20.55C45.1717 19.29 46.0017 18.32 47.0617 17.64C48.1417 16.96 49.3917 16.62 50.8117 16.62ZM50.7817 18.78C49.5217 18.78 48.5217 19.19 47.7817 20.01C47.0617 20.81 46.6317 21.93 46.4917 23.37H54.6817C54.6617 22.01 54.3417 20.91 53.7217 20.07C53.1017 19.21 52.1217 18.78 50.7817 18.78ZM64.4894 33L58.3994 16.92H61.2194L64.6394 26.4C64.7994 26.84 64.9694 27.33 65.1494 27.87C65.3294 28.41 65.4894 28.93 65.6294 29.43C65.7694 29.93 65.8694 30.34 65.9294 30.66H66.0494C66.1094 30.34 66.2194 29.93 66.3794 29.43C66.5394 28.91 66.7094 28.39 66.8894 27.87C67.0694 27.33 67.2394 26.84 67.3994 26.4L70.8194 16.92H73.6394L67.5194 33H64.4894ZM90.1637 24.93C90.1637 27.59 89.4837 29.65 88.1237 31.11C86.7837 32.57 84.9637 33.2999 82.6637 33.2999C81.2437 33.2999 79.9737 32.9799 78.8537 32.34C77.7537 31.68 76.8837 30.73 76.2437 29.49C75.6037 28.23 75.2837 26.71 75.2837 24.93C75.2837 22.27 75.9437 20.22 77.2637 18.78C78.6037 17.34 80.4337 16.62 82.7537 16.62C84.1937 16.62 85.4737 16.95 86.5937 17.61C87.7137 18.25 88.5837 19.19 89.2037 20.43C89.8437 21.65 90.1637 23.15 90.1637 24.93ZM78.0137 24.93C78.0137 26.83 78.3837 28.3399 79.1237 29.4599C79.8837 30.5599 81.0837 31.11 82.7237 31.11C84.3437 31.11 85.5337 30.5599 86.2937 29.4599C87.0537 28.3399 87.4337 26.83 87.4337 24.93C87.4337 23.03 87.0537 21.54 86.2937 20.46C85.5337 19.38 84.3337 18.84 82.6937 18.84C81.0537 18.84 79.8637 19.38 79.1237 20.46C78.3837 21.54 78.0137 23.03 78.0137 24.93ZM96.9878 33H94.3478V10.2H96.9878V33ZM105.622 33L99.5322 16.92H102.352L105.772 26.4C105.932 26.84 106.102 27.33 106.282 27.87C106.462 28.41 106.622 28.93 106.762 29.43C106.902 29.93 107.002 30.34 107.062 30.66H107.182C107.242 30.34 107.352 29.93 107.512 29.43C107.672 28.91 107.842 28.39 108.022 27.87C108.202 27.33 108.372 26.84 108.532 26.4L111.952 16.92H114.772L108.652 33H105.622ZM123.527 16.62C124.887 16.62 126.067 16.92 127.067 17.52C128.067 18.12 128.827 18.97 129.347 20.07C129.887 21.15 130.157 22.42 130.157 23.88V25.47H119.147C119.187 27.29 119.647 28.68 120.527 29.6399C121.427 30.58 122.677 31.0499 124.277 31.0499C125.297 31.0499 126.197 30.96 126.977 30.78C127.777 30.58 128.597 30.3 129.437 29.94V32.25C128.617 32.61 127.807 32.8699 127.007 33.0299C126.207 33.2099 125.257 33.2999 124.157 33.2999C122.617 33.2999 121.267 32.99 120.107 32.3699C118.947 31.7499 118.037 30.83 117.377 29.61C116.737 28.39 116.417 26.88 116.417 25.08C116.417 23.32 116.707 21.81 117.287 20.55C117.887 19.29 118.717 18.32 119.777 17.64C120.857 16.96 122.107 16.62 123.527 16.62ZM123.497 18.78C122.237 18.78 121.237 19.19 120.497 20.01C119.777 20.81 119.347 21.93 119.207 23.37H127.397C127.377 22.01 127.057 20.91 126.437 20.07C125.817 19.21 124.837 18.78 123.497 18.78Z"
          fill="black"
        />
        <path opacity="0.6" d="M28.4653 18.6106H7.96997V22.4901H28.4653V18.6106Z" fill="#68CCA6" />
        <path opacity="0.6" d="M36.7849 29.0745H14V32.9557H36.7849V29.0745Z" fill="#68CCA6" />
        <g filter="url(#filter0_d_289_1448)">
          <path
            d="M5.18745 21.0139C4.86558 20.5651 4.96849 19.9404 5.41729 19.6185L24.407 6L26.9946 9.60821L8.00494 23.2267C7.55613 23.5486 6.93139 23.4457 6.60953 22.9969L5.18745 21.0139Z"
            fill="#55A285"
          />
        </g>
        <g filter="url(#filter1_d_289_1448)">
          <path
            d="M38.8072 30.4002C39.129 30.849 39.0261 31.4737 38.5773 31.7956L19.5877 45.4141L17.0001 41.8059L35.9897 28.1874C36.4385 27.8655 37.0632 27.9684 37.3851 28.4172L38.8072 30.4002Z"
            fill="#55A285"
          />
        </g>
        <g filter="url(#filter2_d_289_1448)">
          <path
            d="M28.3226 17.7964L11.888 29.5428C11.4387 29.8639 11.3348 30.4885 11.6559 30.9378L13.0749 32.9231C13.396 33.3724 14.0206 33.4763 14.4699 33.1551L30.9045 21.4088C31.3538 21.0876 31.4577 20.463 31.1365 20.0137L29.7176 18.0285C29.3965 17.5792 28.7719 17.4753 28.3226 17.7964Z"
            fill="#55A285"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_289_1448"
          x="1"
          y="3"
          width="29.9946"
          height="25.4141"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_289_1448" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_289_1448"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_289_1448"
          x="13"
          y="25"
          width="29.9946"
          height="25.4141"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_289_1448" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_289_1448"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_289_1448"
          x="7.46948"
          y="14.6099"
          width="27.8535"
          height="23.7317"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_289_1448" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_289_1448"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_289_1448">
          <rect width="133" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
